import { render } from "./ModalCore.vue?vue&type=template&id=40445212"
import script from "./ModalCore.vue?vue&type=script&lang=js"
export * from "./ModalCore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__